module.exports = __webpack_public_path__ + "img/jueyuanchejian_tu.061f6b74.png";